import React from 'react'

const Landing = () => {
  return (
    <div className="img_wrp gradient-background">
      <img src={require("../img/proImg/fallback_new.png")} alt="" />
    </div>
  );
}

export default Landing
